import { IPartUploadValidationResult } from '@module/shared';

export async function UploadSpareParts(file: File) {
  const url = `${environmentSettings.webapiUrl}/v1/Upload`;

  const formData = new FormData();
  formData.append('uploadedFile', file);

  const options = {
    method: 'post',
    body: formData
  };
  const response = await fetch(url, options);
  const contentType = response.headers.get('content-type');

  if (response.ok && contentType && contentType.indexOf('application/json') !== -1) {
    const json = await response.json();
    return mapApiUploadResult(json);
  } else {
    return Promise.reject(`System error: ${response.status} ${response.statusText}`);
  }
}

function mapApiUploadResult(apiData: any) {
  try {
    let matchedValues = 0;
    let unmatchedValues = 0;
    apiData.uploadedParts.forEach((elem: any) => {
      if (elem.matched) {
        matchedValues++;
      } else {
        unmatchedValues++;
      }
    });
    const uploadResult: IPartUploadValidationResult = {
      upload: apiData.upload,
      UploadedParts: apiData.uploadedParts,
      Errors: apiData.errors,
      UploadResultStatus: 
        { 
          TotalParts: apiData.uploadedParts.length, 
          MatchedParts: matchedValues,
          UnMatchedParts: unmatchedValues,
          SparePartsUploadID: apiData.upload ? apiData.upload.SparePartsUploadID : ''
        },
      status: apiData.status,
      statusText: apiData.statusText
      };
    return uploadResult;
  } catch (err) {
    //Check in case of parsing errors/exceptions
  }
}
